<template>
  <dialog-reset height="75vh" top="5vh" width="80%" title="选择翻车机报警记录" :visible.sync="visible">
    <div>
      <avue-crud v-if="visible" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :permission="permissionList" :before-open="beforeOpen" v-model="form" ref="crud" @row-update="rowUpdate" @row-save="rowSave"
        @row-del="rowDel" @search-change="searchChange" @search-reset="searchReset" @selection-change="selectionChange" @current-change="currentChange" @size-change="sizeChange" @refresh-change="refreshChange" @row-dblclick="rowDblClick"
        @on-load="onLoad">
      </avue-crud>
    </div>
  </dialog-reset>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getWagonAlarmRecordPage } from "../api";

export default {
  mixins: [crudMixins],
  name: 'SelectWagonAlarmRecordList',
  data () {
    return {
      apiConfig: { getList: getWagonAlarmRecordPage },
      defaultParams: {},
      visible: false,
      query: {},
      option: {
        cancelHijack: true,
        maxHeight: '380',
        searchShow: true,
        searchSpan: 6,
        searchMenuSpan: 24,
        searchMenuPosition: 'right',
        menu: false,
        calcHeight: 30,
        tip: false,
        border: true,
        index: true,
        addBtn: false,
        viewBtn: true,
        dialogClickModal: false,
        searchLabelWidth: 90,
        indexLabel: '序号',
        align: 'center',
        labelWidth: 135,
        column: [
          {
            label: '报警编号',
            prop: 'alarmNo',
          },
          {
            label: '作业编号',
            prop: 'operationNo',
            search: true, // 查询是否显示
          },
          {
            label: "报警类型",
            prop: "alarmType",
            type: 'select',
            overHidden: true,
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=wagon_alarm_type",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择报警类型', trigger: 'change'}
            ],
          },
          {
            label: "报警级别",
            prop: "alarmLevel",
            type: 'select',
            overHidden: true,
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=wagon_alarm_level",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择报警级别', trigger: 'change'}
            ],
          },
          {
            label: '报警时间',
            prop: 'alarmTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 120,
          },
          {
            label: "报警状态",
            prop: "alarmStatus",
            type: 'select',
            overHidden: true,
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=wagon_alarm_status",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择报警状态', trigger: 'change'}
            ],
          },
          {
            label: '报警内容',
            prop: 'alarmContent',
            type: "textarea",
            span: 24,
            minRows: 3,
            hide: true,
            search: false, // 不参与查询
          },
          {
            label: '设备编码',
            prop: 'deviceCode',
          },
          {
            label: '备注',
            prop: 'remark',
            type: "textarea",
            span: 24,
            minRows: 3,
            hide: true,
            search: false, // 不参与查询
          },
        ],
      },
    }
  },
  created () { },
  methods: {
    open () {
      this.visible = true
    },
    // 双击行选择
    rowDblClick (item) {
      this.$emit('replace', item)
      this.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .avue-crud__menu {
  display: none;
}
</style>
